module.exports = __webpack_public_path__ + "img/dewytree.86d74f4e.svg";